module.exports = __webpack_public_path__ + "img/27.2.TN.07d21ebc.png";